import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import homepage from './HomePage.module.css';
import logo from '../../Icon-1024.png';
import { ref, get } from 'firebase/database';
import { database, auth } from '../../firebase';
import HeaderButtons from '../HeaderButtons/HeaderButtons';

const HomePage = () => {
    const [pin, setPin] = useState(['', '', '', '', '', '']);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const inputRefs = useRef([]);
    const hiddenInputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setIsLoggedIn(!!user);
        });
        return () => unsubscribe();
    }, []);

    const handleChange = (index, e) => {
        const value = e.target.value.replace(/\D/g, '');
        const newPin = [...pin];

        if (value) {
            newPin[index] = value;
        } else {
            newPin[index] = '';
        }

        setPin(newPin);

        if (value && index < pin.length - 1) {
            inputRefs.current[index + 1].focus();
        } else if (index === pin.length - 1 && value) {
            hiddenInputRef.current.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && index > 0 && !pin[index]) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const completePin = pin.join('');

        if (pin.some(digit => digit === '')) {
            setErrorMessage('Please fill in all PIN boxes.');
            return;
        }

        try {
            const sessionRef = ref(database, `Sessions/${completePin}`);
            const snapshot = await get(sessionRef);

            if (snapshot.exists()) {
                navigate(`/session/${completePin}`);
            } else {
                setErrorMessage('Session Not Found');
            }
        } catch (error) {
            console.error('Error validating PIN:', error);
            setErrorMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className={homepage['homepage-container']}>
            <HeaderButtons />
            <div className={homepage['homepage-content']}>
                <div className={homepage['card']}>
                    <img src={logo} alt="Logo" className={homepage['logo']} />
                    <form onSubmit={handleSubmit}>
                        <div className={homepage['form-group']}>
                            <div className={homepage['pin-area']}>
                                {pin.slice(0, 3).map((digit, index) => (
                                    <input
                                        key={index}
                                        type="number"
                                        value={digit}
                                        onChange={(e) => handleChange(index, e)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                        className={homepage['pin-input']}
                                        maxLength="1"
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        autoComplete="off"
                                    />
                                ))}
                                <div className={homepage['pin-placeholder']}>-</div>
                                {pin.slice(3, 6).map((digit, index) => (
                                    <input
                                        key={index + 3}
                                        type="number"
                                        value={digit}
                                        onChange={(e) => handleChange(index + 3, e)}
                                        onKeyDown={(e) => handleKeyDown(index + 3, e)}
                                        className={homepage['pin-input']}
                                        maxLength="1"
                                        ref={(el) => (inputRefs.current[index + 3] = el)}
                                        autoComplete="off"
                                    />
                                ))}
                            </div>
                            <input
                                type="text"
                                style={{ position: 'absolute', opacity: 0, height: 0, width: 0 }}
                                ref={hiddenInputRef}
                                onFocus={() => {}}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        document.querySelector('.join-button').click();
                                    }
                                }}
                            />
                            <button type="submit" className={homepage['join-button']}>Join</button>
                            {errorMessage && <div className={homepage['error-message']}>{errorMessage}</div>}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default HomePage;